module.exports = {
  NODE_DOCUMENT: 'document',
  NODE_TAG: 'tag',
  NODE_TEXT: 'text',
  NODE_DOCTYPE: 'doctype',
  NODE_COMMENT: 'comment',
  NODE_SCRIPT: 'script',
  NODE_STYLE: 'style'
}
